import { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { db } from "../firebase/firebase";
import { doc, getDoc } from "firebase/firestore";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { ToWords } from 'to-words';

export default function InvoicePreview() {
  const [searchParams] = useSearchParams();
  const invoiceId = searchParams.get("inv");

  const [invoice, setInvoice] = useState(null);
  const invoiceRef = useRef();

  useEffect(() => {
    const fetchInvoice = async () => {
      const snap = await getDoc(doc(db, "invoices", invoiceId));
      if (snap.exists()) {
        setInvoice(snap.data());
      }
    };

    fetchInvoice();
  }, [invoiceId]);

  if (!invoice) return <div className="text-white">Loading...</div>;


  const units = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  const tens = ["", "Ten", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];

  const toWords = new ToWords({
    localeCode: 'en-IN', // Use 'en-US' for International system
    converterOptions: {
      currency: true,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: false,
    }
  });


  return (
    <div className="p-6 bg-gray-900 min-h-screen text-white">

      {/* 🔘 ACTION BUTTONS */}
      <div className="flex gap-4 mb-6">
        <button
          onClick={async () => {
            const canvas = await html2canvas(invoiceRef.current);
            const img = canvas.toDataURL("image/png");

            const pdf = new jsPDF("p", "mm", "a4");
            pdf.addImage(img, "PNG", 0, 0, 210, 297);
            pdf.save(`${invoice.invoiceNo}.pdf`);
          }}
          className="bg-green-500 px-4 py-2 rounded"
        >
          Download PDF
        </button>

        <button
          onClick={() => window.print()}
          className="bg-blue-500 px-4 py-2 rounded"
        >
          Print
        </button>
      </div>


      {/* 🧾 INVOICE ONLY AREA */}
      <div id="invoice" ref={invoiceRef} className="bg-white text-black p-8 max-w-4xl mx-auto a4-page flex flex-col">

        <div className="flex-grow">
          {/* HEADER */}
          <div className="flex justify-between border-b border-b-2 border-gray-400 pb-4">
            <div>
              <h1 className="text-2xl font-bold">SKILLAURA INSTITUTE</h1>
              <p>H no 952, Civil Lines, Maya Nagar</p>
              <p>Ludhiana, 141001</p>
              <p>GSTIN/UIN: 03EGEPB0928J1ZS</p>
              <p>State Name: Punjab, Code: 03</p>
              <p>Phone: 9115558826</p>
              <p>E-Mail: skillaura.info@gmail.com</p>
            </div>

            <div className="text-right">
              <h2 className="text-xl font-bold">TAX INVOICE</h2>
              <p>Invoice No: {invoice.invoiceNo}</p>
              <p>Date: {invoice.date}</p>
            </div>
          </div>

          {/* CUSTOMER */}
          <div className="mt-3 border-b border-b-2 border-gray-400 pb-4">
            <div>
              <h3 className="font-semibold mb-1">Customer: </h3>
              <p className="capitalize">{invoice.studentName}</p>
              <p className="text-sm">Place of Supply: Punjab (Code: 03)</p>
            </div>

            {/* <div>
              <h3 className="font-semibold mb-2">Course</h3>
              <p>{invoice.course}</p>
            </div> */}
          </div>

          <h3 className="font-bold mt-4">Course Details:</h3>
          {/* TABLE */}
          <table className="w-full mt-3 border text-sm">
            <thead className="bg-gray-200">
              <tr>
                <th className="border border-2 border-gray-400 p-2">S no</th>
                <th className="border border-2 border-gray-400 p-2">Description</th>
                <th className="border border-2 border-gray-400 p-2">SAC Code</th>
                <th className="border border-2 border-gray-400 p-2">Qty</th>
                <th className="border border-2 border-gray-400 p-2">Base</th>
                <th className="border border-2 border-gray-400 p-2">CGST (9%)</th>
                <th className="border border-2 border-gray-400 p-2">SGST (9%)</th>
                <th className="border border-2 border-gray-400 p-2">Total</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td className="border border-2 border-gray-400 p-2 text-center">
                  1
                </td>
                <td className="border border-2 border-gray-400 p-2">
                  Training in {invoice.course}
                </td>
                <td className="border border-2 border-gray-400 p-2 text-center">
                  999294
                </td>
                <td className="border border-2 border-gray-400 p-2 text-center">
                  1
                </td>
                <td className="border border-2 border-gray-400 p-2 text-center">
                  ₹{(invoice.amount / 1.18).toFixed(2)}
                </td>
                <td className="border border-2 border-gray-400 p-2 text-center">
                  ₹{((invoice.amount - (invoice.amount / 1.18)) / 2).toFixed(2)}
                </td>
                <td className="border border-2 border-gray-400 p-2 text-center">
                  ₹{((invoice.amount - (invoice.amount / 1.18)) / 2).toFixed(2)}
                </td>
                <td className="border border-2 border-gray-400 p-2 text-center">
                  ₹{invoice.amount.toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>

          {/* TOTAL */}
          <div className="mt-6 flex justify-end text-end">
            <div className="w-64 space-y-2">
              <p>Base: ₹{(invoice.amount / 1.18).toFixed(2)}</p>
              <p>CGST (9%): ₹{((invoice.amount - (invoice.amount / 1.18)) / 2).toFixed(2)}</p>
              <p>SGST (9%):₹{((invoice.amount - (invoice.amount / 1.18)) / 2).toFixed(2)}</p>
              <p className="font-bold text-lg">Total: ₹{invoice.amount.toFixed(2)}</p>
            </div>
          </div>

        </div>

        {/* FOOTER */}
        <div className="mt-10 border-t border-t-2 border-gray-400 pt-4 text-sm">
          <p>Payment Mode: {invoice.paymentMode}</p>
          <p>Payment Status: Paid</p>
          <p>
            Amount Chargeable (in words) <b>INR {toWords.convert(invoice.amount)}</b>
          </p>
          <div className="mt-6 flex justify-between gap-3">

            <div className="w-1/2 p-3 border border-2 border-gray-400">
              <b>Declaration</b><br />
              We declare that this invoice shows the actual price of the services described and that all particulars are true and correct.
              <br />
              <br />
              <br />
              • Fees once paid are non-refundable
            </div>
            <div className="w-1/2 p-3 border border-2 border-gray-400">
              <b>Company's Bank Details</b><br />
              Bank Name : <b>SBI BANK</b><br />
              A/c No. : <b>44949737630</b><br />
              Branch & IFS Code: <b>Ghumar Mandi - LUDHIANA &
                SBIN0050170</b><br />
              <p className="text-end font-bold">
                for SKILLAURA INSTITUTE<br />
                Authorised Signatory
              </p>
            </div>
          </div>
        </div>
        <p className="text-center text-sm font-[500]">(This is a computer-generated invoice and does not require a physical signature)</p>
      </div>

      {/* 🔥 PRINT CSS */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            #invoice, #invoice * {
              visibility: visible;
            }
            #invoice {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
            }
          }
        `}
      </style>

    </div>
  );
}